import React, { FC, useState, useEffect } from 'react';
import { LawyerCardInfosType } from '../lawyer.types';
import { fetchLawyerInfos } from '../lawyer.api';
import { LawyerPopoverCard } from './LawyerPopoverCard';
import { PopoverWrapper } from '../../components/popovers/wrapper/PopoverWrapper';
import { PopoverLoading } from '../../components/popovers/loading/PopoverLoading';
import { delayPromise } from '../../utils/promise';
import { doctrineAnalytics } from '../../utils/analyticsUtils';

type Props = {
  lawyerId: string;
  source: string;
};

export const LawyerPopover: FC<Props> = ({ lawyerId, source }) => {
  const [lawyerInfos, setLawyerInfos] = useState<LawyerCardInfosType | null>(
    null,
  );
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    async function fetch() {
      setLoading(true);
      const lawyerInfosFetched = await delayPromise(
        fetchLawyerInfos(lawyerId),
        300,
      );
      doctrineAnalytics('DisplayLawyerPopover');
      setLawyerInfos(lawyerInfosFetched);
      setLoading(false);
    }
    fetch();
  }, [lawyerId]);

  if (isLoading)
    return (
      <PopoverWrapper>
        <PopoverLoading />
      </PopoverWrapper>
    );

  if (!lawyerInfos) return null;

  return (
    <PopoverWrapper>
      <LawyerPopoverCard
        lawyer={{
          ...lawyerInfos,
          title: lawyerInfos.name,
        }}
        source={source}
      />
    </PopoverWrapper>
  );
};
